import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import {
  Box,
  Button,
  Container,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material';
import { useState } from 'react';

import InformationSubMenu from '@/components/nav/InformationSubMenu';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
// import type { LayoutWrapperContents } from '@/types/LayoutWrapperContents';

const Form1099NewHampshire = () => {
  const [open, setOpen] = useState(false);

  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading: `Extend your business tax return deadline with Form 7004.`,
  //   SubHeading:
  //     'E-file now and get more time to ensure accuracy. File now for peace of mind.',
  //   CtaText: 'E-file Form 7004 Now',
  //   CtaSubHeading: `Takes 3 steps and less than 5 minutes`,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=sticky`,
  //   isActive: true,
  // };

  return (
    <AppLayout
      //  LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="Form 1099 State Filing Requirements for New Hampshire | TaxZerone"
          description="Easily stay compliant with New Hampshire Form 1099 filing requirements. Learn more about the New Hampshire reporting process for state information returns."
          keywords=" "
          canonical="form-1099-state-filing/new-hampshire-filing-requirements/"
          jsonLdPricing="0.99"
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount="57448"
          ogShareImg="assets/images/information-share-img.png"
        />
      }
    >
      <InformationSubMenu />
      <ComingSoonPopup open={open} setOpen={setOpen} />

      <Container maxWidth="xl" component="section">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Hidden mdDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/state-nh-landing-img.webp" />
                <source srcSet="/assets/images/state-nh-landing-img.png" />
                <img
                  src="/assets/images/state-nh-landing-img.png"
                  alt="Effortless Form 1099 Filing in New Hampshire"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>

          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                Effortless{' '}
                <span className="highlight-container">
                  <span className="highlight">Form 1099</span>
                </span>{' '}
                Filing in
                <Hidden smDown>
                  <br />
                </Hidden>{' '}
                <span className="highlight-container">
                  <span className="highlight">New Hampshire</span>
                </span>
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                }}
              >
                New Hampshire does not require state 1099 filing, but the IRS
                still does. Ensure compliance by accurately reporting
                non-employee compensation, rent, interest, and other payments.
              </Typography>
              <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Box sx={{ textAlign: 'center', mr: { xs: 0, md: 4 } }}>
                  <Button
                    variant="contained"
                    className="btn-primary"
                    sx={{
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1099nh`}
                  >
                    Start Filing Now!{' '}
                    {/* <Box
                      component={'span'}
                      sx={{ ml: 1, color: '#eaff00', fontWeight: 700 }}
                    >
                      Your W-2 Today!
                    </Box> */}
                  </Button>
                </Box>
              </Stack>
            </Box>
          </Box>
          <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/state-nh-landing-img-sm.webp" />
                <source srcSet="/assets/images/state-nh-landing-img-sm.png" />
                <img
                  src="/assets/images/state-nh-landing-img-sm.png"
                  alt="Effortless Form 1099 Filing in New Hampshire"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>

      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            direction={{ md: 'row', xs: 'column-reverse' }}
            sx={{ pt: 5, pb: 5 }}
          >
            <Grid
              size={{ xs: 12, sm: 6 }}
              sx={{
                textAlign: { md: 'left', xs: 'center' },
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
              }}
            >
              <Box sx={{ px: { md: 0, sm: 0, xs: 2 } }}>
                {' '}
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: { md: 3, sm: 1, xs: 0 },
                    pt: { md: 0, sm: 3 },
                    textAlign: { md: 'left', sm: 'center' },
                  }}
                >
                  Filing Form 1099 in New Hampshire: What You Need to Know
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Since New Hampshire has no state income tax, businesses are
                  <span style={{ fontWeight: 600 }}> not required</span> to file
                  Form 1099 at the state level. However,
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    federal filing remains mandatory
                  </span>
                  . The IRS requires businesses to report{' '}
                  <Hidden smDown>
                    {' '}
                    <br />
                  </Hidden>
                  non-employee compensation, rent, interest, and other
                  qualifying payments, along with any withheld federal taxes.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Stay compliant and avoid IRS penalties by e-filing Form 1099
                  with
                  <span style={{ fontWeight: 600 }}> TaxZerone</span>—an
                  IRS-authorized provider. Experience a fast, secure, and
                  hassle-free filing process.
                </Typography>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }} sx={{ textAlign: 'center' }}>
              <Box>
                <picture>
                  <source srcSet="/assets/images/who-file-nh-img.webp" />
                  <source srcSet="/assets/images/who-file-nh-img.png" />
                  <img
                    src="/assets/images/who-file-nh-img.png"
                    alt="Filing Form 1099 in New Hampshire: What You Need to Know"
                    className="img-responsive img-shadow"
                    loading="lazy"
                    width={400}
                    height={400}
                  />
                </picture>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Box
        component="section"
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          E-File Your IRS Forms Effortlessly with TaxZerone
        </Typography>

        <Box
          sx={{
            textAlign: 'center',
            justifyContent: 'center',
            mb: 2,
          }}
        >
          <Stack
            spacing={1}
            direction={{ xs: 'column', sm: 'row' }}
            sx={{
              textAlign: 'center',
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
              m: 0,
            }}
          >
            <Box>
              <List>
                <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                  <ListItemIcon
                    sx={{
                      minWidth: 'inherit',
                      mr: 1,
                      mt: 0.6,
                      color: '#1d1917',
                    }}
                  >
                    <CheckCircleIcon />
                  </ListItemIcon>
                  <ListItemText sx={{ color: '#f3f3f3' }}>
                    Fast and accurate filing
                  </ListItemText>
                </ListItem>
                <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                  <ListItemIcon
                    sx={{
                      minWidth: 'inherit',
                      mr: 1,
                      mt: 0.6,
                      color: '#1d1917',
                    }}
                  >
                    <CheckCircleIcon />
                  </ListItemIcon>
                  <ListItemText sx={{ color: '#f3f3f3' }}>
                    Simplify bulk filing in minutes
                  </ListItemText>
                </ListItem>
              </List>
            </Box>
            <Box>
              <List>
                <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                  <ListItemIcon
                    sx={{
                      minWidth: 'inherit',
                      mr: 1,
                      mt: 0.6,
                      color: '#1d1917',
                    }}
                  >
                    <CheckCircleIcon />
                  </ListItemIcon>
                  <ListItemText sx={{ color: '#f3f3f3' }}>
                    Stay compliant with IRS regulations
                  </ListItemText>
                </ListItem>
                <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                  <ListItemIcon
                    sx={{
                      minWidth: 'inherit',
                      mr: 1,
                      mt: 0.6,
                      color: '#1d1917',
                    }}
                  >
                    <CheckCircleIcon />
                  </ListItemIcon>
                  <ListItemText sx={{ color: '#f3f3f3' }}>
                    Get the best pricing in the industry
                  </ListItemText>
                </ListItem>
              </List>
            </Box>
          </Stack>
        </Box>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1099nh`}
          >
            E-file Now
          </Button>
        </Box>
      </Box>
    </AppLayout>
  );
};

export default Form1099NewHampshire;
